import { render, staticRenderFns } from "./ConsolidationOrdersFilter.vue?vue&type=template&id=36fbe184&scoped=true"
import script from "./ConsolidationOrdersFilter.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbe184",
  null
  
)

export default component.exports